import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlinedAlert } from 'Images';

interface IInfo {
  showError: boolean;
}

export const Info = ({ showError }: IInfo) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback).info;
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction={'row'}
      sx={{
        alignItems: isDesktop ? 'center' : 'flex-start',
        gap: '6px',
        mt: '8px',
      }}
    >
      {showError ? (
        <Typography
          role='alert'
          aria-live='assertive'
          variant='body6'
          sx={{
            color: '#E12D2D',
            maxWidth: '600px',
          }}
        >
          {dictionary.sizeError}
        </Typography>
      ) : (
        <>
          <Avatar
            alt=''
            src={PurpleOutlinedAlert}
            sx={{ height: '24px', width: '24px' }}
          />
          <Typography variant='body6'>
            {isDesktop ? dictionary.info : dictionary.infoMobile}
          </Typography>
        </>
      )}
    </Stack>
  );
};
